"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionAndAnswersSchema = void 0;
exports.QuestionAndAnswersSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/question-and-answers.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "QuestionAndAnswers",
    "description": "Consists of 1 question and 1-n answers to it. Connect multiple to form interviews.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:question-and-answers"
            ]
        },
        "question": {
            "$ref": "https://www.redbull.com/schemas/attributes/quote.schema.json"
        },
        "answers": {
            "type": "array",
            "items": {
                "$ref": "https://www.redbull.com/schemas/attributes/quote.schema.json"
            }
        }
    },
    "required": [
        "type",
        "question",
        "answers"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlc3Rpb24tYW5kLWFuc3dlcnMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9xdWVzdGlvbi1hbmQtYW5zd2Vycy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSx3QkFBd0IsR0FBRztJQUN0QyxLQUFLLEVBQUUsNkVBQTZFO0lBQ3BGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLG9CQUFvQjtJQUM3QixhQUFhLEVBQUUsb0ZBQW9GO0lBQ25HLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLGlDQUFpQzthQUNsQztTQUNGO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsTUFBTSxFQUFFLDhEQUE4RDtTQUN2RTtRQUNELFNBQVMsRUFBRTtZQUNULE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRSw4REFBOEQ7YUFDdkU7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLFVBQVU7UUFDVixTQUFTO0tBQ1Y7Q0FDRixDQUFBIn0=